(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('telephoneField', TelephoneField);

    /** @ngInject */
    function TelephoneField($filter, HelperService, PhoneTypeService, PATHS) {
        function TelephoneFieldController($scope) {
            const vm = this;

            vm.getNumber = num => {
                return new Array(num);
            }

            vm.addPhone = () => {
                vm.amountOfPhones++;
            }

            vm.removePhone = index => {
                vm.telephones.splice(index, 1);

                vm.amountOfPhones--;
            }

            vm.getPhoneTypes = () => {
                HelperService.startLoading('.phone-container', true);

                return PhoneTypeService
                    .getAll()
                    .then(success => {
                        vm.phoneTypes = success;
                        HelperService.stopLoading('.phone-container');
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.phone-container');
                    });
            }

            vm.handleConfigurePhones = phones => {
                vm.amountOfPhones = 1;
                let editableTelephones = angular.copy(phones);

                if (editableTelephones && editableTelephones.length) {
                    vm.amountOfPhones = editableTelephones.length;

                    editableTelephones.filter(telephone => telephone && telephone.Phone).map(telephone => {
                        telephone.PhoneComplete = $filter('formatPhoneComplete')(telephone.Phone.Code + telephone.Phone.Number);
                    });
                } else
                    editableTelephones = [];

                if (vm.amountOfPhones == 0)
                    vm.amountOfPhones = 1;

                vm.editableTelephones = editableTelephones;
            }

            const removeWatchField = $scope.$watch('vm.editableTelephones', (newTelephones, oldTelephones) => {
                if (angular.equals(oldTelephones, newTelephones)) return;

                let localEditedTelephones = angular.copy(newTelephones);

                for (let index = 0; index < localEditedTelephones.length; index++) {
                    const telephone = localEditedTelephones[index];

                    if (!telephone.PhoneComplete) continue;

                    const phoneClean = telephone.PhoneComplete.replace(/\D/g, '');

                    if (telephone.Phone) {
                        telephone.Phone.Code = phoneClean.slice(0, 2);
                        telephone.Phone.Number = phoneClean.slice(2);
                    } else {
                        telephone.Phone = {
                            Code: phoneClean.slice(0, 2),
                            Number: phoneClean.slice(2)
                        };
                    }

                    delete telephone.PhoneComplete;
                }

                vm.telephones = angular.copy(localEditedTelephones);
            }, true);

            $scope.$on('$destroy', () => {
                removeWatchField();
            });

            init();

            function init() {
                vm.editableTelephones = [];
                vm.phoneTypes = [];
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getPhoneTypes()
                .then(() => ctrl.handleConfigurePhones(ctrl.telephones));

            let removeWatchPhones = scope.$watch(() => {
                return ctrl.telephones;
            }, (newTelephones, oldTelephones) => {
                if (angular.equals(oldTelephones, newTelephones)) return;

                ctrl.handleConfigurePhones(newTelephones);
            });

            scope.$on('$destroy', () => {
                removeWatchPhones();
            });
        }

        return {
            bindToController: true,
            controller: TelephoneFieldController,
            controllerAs: 'vm',
            restrict: 'AE',
            link: link,
            templateUrl: `${PATHS.PHYSICAL}/directives/telephone-field/telephone-field.html`,
            scope: {
                telephones: '=',
                canEdit: '='
            },
        }
    }
}());